<!-- widget Control configuration -->
<div *ngIf="expansionStyle == 'body'">

    <div class="config__bottom_border">
        <div class="auto-flex">
            <div class="leftDiv">
                <div class="c-title--subsection">Populate Catalog Configuration</div>
            </div>
            <div class="rightDiv">
                <ccl-toggle-button
                    [title]="sessionWidgetConfig.widget.applyCatalogConfiguration ? 'Enable' : 'Disable'"
                    [isChecked]="sessionWidgetConfig.widget.applyCatalogConfiguration"
                    (isCheckedChange)="toggleApplyCatalogConfiguration($event)">
                    {{ sessionWidgetConfig.widget.applyCatalogConfiguration ? "Enabled" : "Disabled" }}
                </ccl-toggle-button>
            </div>
            
            <div class="rightDiv margin-rt5" title="Reset Default Configuration" *ngIf="sessionWidgetConfig.widget.applyCatalogConfiguration">
                <button class="c-btn c-btn--primary reset-config-btn" (cclClick)="resetThemeConfiguration()">
                    <i class="fa fa-refresh" [ngClass]="{'fa-spin' : resetLoading}"></i>
                </button>
            </div>		
            <div style="clear:both"></div>
        </div>
    </div>

    <!-- <div class="c-title--subsection">Display Color Configuration</div> -->
    <div class="row ptop10" *ngIf="!displayThemeConfiguration">

        <!-- widgetItemBackgroundColor --widget-item-background-color -->
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="pluginItemBackgroundColor">Plugin Item Background</label>
                </div>
                <div
                    class="input-group"
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(colorPicker)]="widgetConfiguration.widgetItemBackgroundColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'right'"
                >
                    <input id="pluginItemBackgroundColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="widgetConfiguration.widgetItemBackgroundColor"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': widgetConfiguration.widgetItemBackgroundColor }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <!-- widgetBackgroundColor --widget-background-color -->
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="pluginBackgroundColor">Plugin Background</label>
                </div>
                <div
                    class="input-group"
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(colorPicker)]="widgetConfiguration.widgetBackgroundColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="pluginBackgroundColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="widgetConfiguration.widgetBackgroundColor"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': widgetConfiguration.widgetBackgroundColor }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        
        <!-- widgetTitleTextColor --widget-title-text-color -->
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="pluginTitleTextColor">Plugin Title Text</label>
                </div>
                <div
                    class="input-group"
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(colorPicker)]="widgetConfiguration.widgetTitleTextColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'right'"
                >
                    <input id="pluginTitleTextColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="widgetConfiguration.widgetTitleTextColor"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': widgetConfiguration.widgetTitleTextColor }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <!-- widgetTitleBackgroundColor --widget-title-background-color -->
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="pluginTitleBackgroundColor">Plugin Title Background</label>
                </div>
                <div
                    class="input-group"
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(colorPicker)]="widgetConfiguration.widgetTitleBackgroundColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="pluginTitleBackgroundColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="widgetConfiguration.widgetTitleBackgroundColor"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': widgetConfiguration.widgetTitleBackgroundColor }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <!-- widgetButtonTextColor --widget-button-text-color -->
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="pluginButtonTextColor">Plugin Buttons Text</label>
                </div>
                <div
                    class="input-group"
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(colorPicker)]="widgetConfiguration.widgetButtonTextColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'top'"
                >
                    <input id="pluginButtonTextColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="widgetConfiguration.widgetButtonTextColor"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': widgetConfiguration.widgetButtonTextColor }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <!-- widgetButtonBackgroundColor --widget-buttons-background-color -->
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="pluginButtonBackgroundColor">Plugin Buttons Background</label>
                </div>
                <div
                    class="input-group"
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(colorPicker)]="widgetConfiguration.widgetButtonBackgroundColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'top'"
                >
                    <input id="pluginButtonBackgroundColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="widgetConfiguration.widgetButtonBackgroundColor"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': widgetConfiguration.widgetButtonBackgroundColor }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <!-- carouselArrowColor --carousel-arrow-color -->
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="pluginArrowColor">Plugin Arrow</label>
                </div>
                <div
                    class="input-group"
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(colorPicker)]="widgetConfiguration.carouselArrowColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'top'"
                >
                    <input id="pluginArrowColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="widgetConfiguration.carouselArrowColor"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': widgetConfiguration.carouselArrowColor }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <!-- carouselArrowBoxColor --carousel-arrow-box-color -->
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="pluginArrowBoxColor">Plugin Arrow Box</label>
                </div>
                <div
                    class="input-group"
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(colorPicker)]="widgetConfiguration.carouselArrowBoxColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'top'"
                >
                    <input id="pluginArrowBoxColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="widgetConfiguration.carouselArrowBoxColor"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': widgetConfiguration.carouselArrowBoxColor }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <!-- carouselDotsColor --carousel-dots-color -->
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="pluginDotsColor">Plugin Dots</label>
                </div>
                <div
                    class="input-group"
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(colorPicker)]="widgetConfiguration.carouselDotsColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'top'"
                >
                    <input id="pluginDotsColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="widgetConfiguration.carouselDotsColor"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': widgetConfiguration.carouselDotsColor }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <!-- carouselDotsInactiveColor --carousel-dots-color -->
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="pluginDotsInactiveColor">Plugin Dots Inactive</label>
                </div>
                <div
                    class="input-group"
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(colorPicker)]="widgetConfiguration.carouselDotsInactiveColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'top'"
                >
                    <input id="pluginDotsInactiveColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="widgetConfiguration.carouselDotsInactiveColor"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': widgetConfiguration.carouselDotsInactiveColor }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </div>

    <!-- <div class="c-title--subsection">Display Theme Configuration</div> -->
    <div class="row ptop10" *ngIf="displayThemeConfiguration">

        <!-- Theme Primary Color style --primary -->
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="themePrimaryColor">Primary</label>
                </div>
                <div
                    class="input-group"
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(colorPicker)]="themeConfiguration.primary"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'right'"
                >
                    <input id="themePrimaryColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="themeConfiguration.primary"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': themeConfiguration.primary }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <!-- Theme Secondary Color-->
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="themeSecondaryColor">Secondary</label>
                </div>
                <div
                    class="input-group"
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(colorPicker)]="themeConfiguration.secondary"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="themeSecondaryColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="themeConfiguration.secondary"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': themeConfiguration.secondary }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        
        <!-- themeBackgroundColor -->
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="themeBackgroundColor">Background</label>
                </div>
                <div
                    class="input-group"
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(colorPicker)]="themeConfiguration.background"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'right'"
                >
                    <input id="themeBackgroundColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="themeConfiguration.background"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': themeConfiguration.background }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <!-- themeTextColor -->
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="themeTextColor">Text</label>
                </div>
                <div
                    class="input-group"
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(colorPicker)]="themeConfiguration.text"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="themeTextColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="themeConfiguration.text"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': themeConfiguration.text }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <!-- themeBodyTextColor -->
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="themeBodyTextColor">Body Text</label>
                </div>
                <div
                    class="input-group"
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(colorPicker)]="themeConfiguration.bodyText"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'top'"
                >
                    <input id="themeBodyTextColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="themeConfiguration.bodyText"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': themeConfiguration.bodyText }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </div>
</div>
